// 建物/部屋編集情報
const PropertyTemplate = {
  namespaced: true,
  state: {
    modal: false,
    list: [],
    template: {
      tmpl: {
        major_category: [],
        small_category: [],
        option: [],
      },
    },
    resolve: null,
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getList: state => {
      return state.list
    },
    getTemplate: state => {
      return state.template
    },
    getResolve: state => {
      return state.resolve
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setList(state, list) {
      state.list = list
    },
    setTemplate(state, template) {
      state.template = template
    },
    setResolve(state, resolve) {
      state.resolve = resolve
    },
  },
  actions: {
    resetTemplate({ commit }) {
      const template = {
        tmpl: {
          major_category: [],
          small_category: [],
          option: [],
        },
      }
      commit('setTemplate', template)
    },
  },
}

export default PropertyTemplate
